import { useWizardStore } from './store/wizard.js';
import { ChatPanel } from './components/chat/ChatPanel.js';
import { GraphPanel } from './components/graph/GraphPanel.js';
import { CandidateStrip } from './components/graph/CandidateStrip.js';
import { ResultScreen } from './components/result/ResultScreen.js';

export function App(): JSX.Element | null {
  const phase = useWizardStore(s => s.phase);
  const error = useWizardStore(s => s.error);
  const reset = useWizardStore(s => s.reset);

  if (phase === 'error') {
    return (
      <main className="flex h-full items-center justify-center p-6">
        <div className="max-w-md text-center">
          <h1 className="font-display text-3xl text-bloom-500">Something went wrong</h1>
          <p className="mt-4 font-body text-ink-600">{error ?? 'Please try again.'}</p>
          <button
            onClick={reset}
            className="mt-6 rounded-md bg-sage-700 px-4 py-2 font-body text-paper-50 hover:bg-sage-900"
          >
            Start over
          </button>
        </div>
      </main>
    );
  }

  if (phase === 'concluded') {
    return <ResultScreen />;
  }

  // idle | asking | awaiting → the conversational scaffold.
  return (
    <main className="flex h-dvh max-h-dvh min-h-0 flex-col overflow-hidden">
      <div className="shrink-0 lg:hidden"><CandidateStrip /></div>
      <div className="grid min-h-0 flex-1 grid-cols-1 overflow-hidden lg:grid-cols-[42%_58%]">
        <ChatPanel />
        <div className="hidden min-h-0 flex-col overflow-hidden lg:flex">
          <div className="min-h-0 flex-1"><GraphPanel /></div>
        </div>
      </div>
    </main>
  );
}
